/******************************************
 *  Author : vsuthar
 *  Created On : Wed Aug 18 2021
 *  File : Page.js
 *  ©Palo Alto Networks
 *******************************************/

import Header from './header/Header'

const Page = ({ pageHeaderProps, children, addClassName = '' }) => {

  const { title, actions, ...restHeaderProps } = pageHeaderProps

  const className = [
    'cm-w-full',
    ...(addClassName.split(' '))
  ].join(' ')

  return (
    <div {...{ className }}>
      <Header title={title} actions={actions} {...restHeaderProps}/>
      {children}
    </div>
  )
}

export default Page
